import { createContext } from 'react'

export interface IBodyClipContext {
	clip(reason: string): void
	unclip(reason: string): void
}

export const bodyClipContext = createContext<IBodyClipContext>({
	clip: () => {},
	unclip: () => {},
})
